import React from 'react';
import { layoutTheme } from "../../../constants/layout";

const LightDark = ({ layoutMode, onChangeLayoutMode }) => {
  const isDark = layoutMode === layoutTheme['DARKMODE'] || layoutMode === 'dark';

  const handleSetMode = (targetMode) => {
    if (onChangeLayoutMode) {
      onChangeLayoutMode(targetMode);
    }
  };

  const handleToggle = () => {
    const nextMode = isDark ? layoutTheme['LIGHTMODE'] : layoutTheme['DARKMODE'];
    handleSetMode(nextMode);
  };

  return (
    <div
      className="theme-switch-pill"
      onClick={handleToggle}
      role="button"
      tabIndex={0}
      title={isDark ? "Switch to Light Mode" : "Switch to Dark Mode"}
    >
      <button
        type="button"
        className={`theme-switch-btn ${!isDark ? 'active' : ''}`}
        onClick={(e) => {
          e.stopPropagation();
          handleSetMode(layoutTheme['LIGHTMODE']);
        }}
        aria-label="Light mode"
        title="Light mode"
      >
        <svg
          width="15"
          height="15"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <circle cx="12" cy="12" r="4" />
          <line x1="12" y1="2" x2="12" y2="4" />
          <line x1="12" y1="20" x2="12" y2="22" />
          <line x1="4.93" y1="4.93" x2="6.34" y2="6.34" />
          <line x1="17.66" y1="17.66" x2="19.07" y2="19.07" />
          <line x1="2" y1="12" x2="4" y2="12" />
          <line x1="20" y1="12" x2="22" y2="12" />
          <line x1="4.93" y1="19.07" x2="6.34" y2="17.66" />
          <line x1="17.66" y1="6.34" x2="19.07" y2="4.93" />
        </svg>
      </button>

      <button
        type="button"
        className={`theme-switch-btn ${isDark ? 'active' : ''}`}
        onClick={(e) => {
          e.stopPropagation();
          handleSetMode(layoutTheme['DARKMODE']);
        }}
        aria-label="Dark mode"
        title="Dark mode"
      >
        <svg
          width="15"
          height="15"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
        </svg>
      </button>
    </div>
  );
};

export default LightDark;